export const translations = {
  da: {
    // General / Common
    siteName: "Porthos Maritime",
    readMore: "Læs mere",
    contact: "Kontakt",
    services: "Ydelser",
    home: "Forside",
    backToHome: "Tilbage til forsiden",
    goToContact: "Gå til kontakt",
    back: "Tilbage",
    
    // SEO Defaults
    seo: {
      home: {
        title: "Maritim Rådgivning & Projektstyring",
        description: "Porthos Maritime leverer professionel rådgivning, projektstyring og operativ support inden for offshore vind, logistik og marine operationer."
      },
      services: {
        title: "Maritime Ydelser & Kompetencer",
        description: "Udforsk vores specialiserede maritime ydelser inden for offshore vind-projekter, maritim logistik og komplekse marine operationer."
      },
      contact: {
        title: "Kontakt Porthos Maritime",
        description: "Kontakt os for en uforpligtende samtale om maritime projekter, offshore vind, logistik eller marine operationer."
      }
    },

    // Home Page
    homeHero: {
      title: "PROJECT MANAGEMENT\nMARINE & OFFSHORE VIND",
      subtitle: "Porthos Maritime leverer professionel rådgivning og operativ support til komplekse projekter i den maritime sektor."
    },
    homeIntro: {
      tag: "Introduktion",
      title: "Én mand. Én vision. Uovertruffen ekspertise.",
      p1: "Porthos Maritime er en personligt drevet virksomhed, der bygger på mange års erfaring fra det maritime erhverv. Jeg mener, at de bedste løsninger findes gennem personlig kontakt, dyb faglig forståelse og en agil tilgang til opgaverne.",
      p2: "Uanset om det drejer sig om store offshore vind-projekter eller komplekse logistiske udfordringer, er jeg din direkte kontaktperson fra start til slut. Dette sikrer korte beslutningsveje og fuldt fokus på dit projekt.",
      badgeTitle: "100%",
      badgeDesc: "Fokus på kvalitet"
    },
    homeB2b: {
      tag: "Maritimt B2B-fokus",
      title: "MARITIM EKSPERTISE OG HANDLEKRAFT",
      p1: "Porthos Maritime er et firma, der bygger på mange års erfaring fra det maritime erhverv. De bedste projekter bliver til med gode folk på de rigtige poster, med dyb faglig forståelse og indsigt i løsning af opgaver, der kræver lidt mere.",
      p2: "Desuden er det vigtigt at kunne se opgaverne fra flere sider, og Porthos Maritime besidder erfaringer fra både ejere, underleverandører og tredje part. Det giver god forståelse for både kontraktlige forhold såvel som multikulturelle forskelle. Dette sikrer korte beslutningsveje og fuldt fokus på projektet."
    },
    homeCta: {
      title: "Klar til næste operation?",
      desc: "Kontakt Porthos Maritime for en uforpligtende samtale om maritime projekter, offshore vind, logistik eller marine operationer."
    },

    // Services Page
    servicesPage: {
      tag: "Maritime kompetencer",
      title: "Specialiseret support til komplekse maritime projekter",
      desc: "De tre ydelsesområder dækker centrale behov i maritime B2B-projekter, hvor præcis koordinering, teknisk indsigt og operativ erfaring er afgørende for et sikkert og effektivt forløb."
    },

    // Service Detail Page
    serviceDetailPage: {
      tag: "Ydelse",
      contactTitle: "Kontakt",
      contactBtn: "Gå til kontakt"
    },

    // Contact Page
    contactPage: {
      title: "Kontakt",
      subtitle: "Tag en samtale med Porthos Maritime om maritime projekter, offshore vind, logistik eller marine operationer.",
      infoTitle: "Kontaktinformation",
      infoDesc: "Udfyld formularen, eller kontakt Porthos Maritime direkte via telefon eller e-mail. Alle henvendelser besvares hurtigst muligt.",
      phone: "Telefon",
      email: "E-mail",
      location: "Lokation",
      availability: "Tilgængelighed",
      availabilityValue: "Mandag - Fredag: 08:00 - 17:00",
      formTitle: "Send en besked"
    },

    // Contact Form
    contactForm: {
      nameLabel: "Navn",
      namePlaceholder: "Fulde navn",
      phoneLabel: "Telefon",
      phonePlaceholder: "Telefonnummer",
      emailLabel: "E-mail",
      emailPlaceholder: "E-mail adresse",
      messageLabel: "Besked",
      messagePlaceholder: "Beskriv projektet eller henvendelsen",
      submitBtn: "Send besked",
      successMsg: "Tak for beskeden. Porthos Maritime vender tilbage hurtigst muligt.",
      errorMsg: "Der opstod en fejl. Prøv venligst igen senere eller ring direkte."
    },

    // Footer
    footer: {
      desc: "Professionel rådgivning og operativ support til komplekse projekter i den maritime sektor.",
      contact: "Kontakt",
      shortcuts: "Genveje",
      allRightsReserved: "Alle rettigheder forbeholdes."
    }
  },
  en: {
    // General / Common
    siteName: "Porthos Maritime",
    readMore: "Read more",
    contact: "Contact",
    services: "Services",
    home: "Home",
    backToHome: "Back to home",
    goToContact: "Go to contact",
    back: "Back",

    // SEO Defaults
    seo: {
      home: {
        title: "Maritime Advisory & Project Management",
        description: "Porthos Maritime delivers professional advisory, project management, and operational support within offshore wind, logistics, and marine operations."
      },
      services: {
        title: "Maritime Services & Competencies",
        description: "Explore our specialized maritime services in offshore wind projects, maritime logistics, and complex marine operations."
      },
      contact: {
        title: "Contact Porthos Maritime",
        description: "Contact us for an informal talk about maritime projects, offshore wind, logistics, or marine operations."
      }
    },

    // Home Page
    homeHero: {
      title: "PROJECT MANAGEMENT\nMARINE & OFFSHORE WIND",
      subtitle: "Porthos Maritime delivers professional advisory and operational support for complex projects in the maritime sector."
    },
    homeIntro: {
      tag: "Introduction",
      title: "One man. One vision. Unmatched expertise.",
      p1: "Porthos Maritime is a personally driven company built on many years of experience from the maritime industry. I believe that the best solutions are found through personal contact, deep professional understanding, and an agile approach to tasks.",
      p2: "Whether it concerns large offshore wind projects or complex logistical challenges, I am your direct contact person from start to finish. This ensures short decision paths and full focus on your project.",
      badgeTitle: "100%",
      badgeDesc: "Focus on Quality"
    },
    homeB2b: {
      tag: "Maritime B2B Focus",
      title: "MARITIME EXPERTISE AND DECISIVENESS",
      p1: "Porthos Maritime is a company built on many years of experience from the maritime industry. The best projects are realized with good people in the right positions, with deep professional understanding and insight into solving tasks that require a little more.",
      p2: "Furthermore, it is important to be able to see tasks from multiple angles, and Porthos Maritime possesses experience from owners, subcontractors, and third parties. This provides a great understanding of both contractual conditions and multicultural differences. This ensures short decision paths and full focus on the project."
    },
    homeCta: {
      title: "Ready for the next operation?",
      desc: "Contact Porthos Maritime for an informal conversation about maritime projects, offshore wind, logistics, or marine operations."
    },

    // Services Page
    servicesPage: {
      tag: "Maritime Competencies",
      title: "Specialized support for complex maritime projects",
      desc: "Our three service areas cover key needs in maritime B2B projects, where precise coordination, technical insight, and operational experience are crucial for a safe and efficient process."
    },

    // Service Detail Page
    serviceDetailPage: {
      tag: "Service",
      contactTitle: "Contact",
      contactBtn: "Go to contact"
    },

    // Contact Page
    contactPage: {
      title: "Contact",
      subtitle: "Have a conversation with Porthos Maritime about maritime projects, offshore wind, logistics, or marine operations.",
      infoTitle: "Contact Information",
      infoDesc: "Fill out the form, or contact Porthos Maritime directly via phone or email. All inquiries are answered as quickly as possible.",
      phone: "Phone",
      email: "Email",
      location: "Location",
      availability: "Availability",
      availabilityValue: "Monday - Friday: 08:00 - 17:00",
      formTitle: "Send a message"
    },

    // Contact Form
    contactForm: {
      nameLabel: "Name",
      namePlaceholder: "Full name",
      phoneLabel: "Phone",
      phonePlaceholder: "Phone number",
      emailLabel: "Email",
      emailPlaceholder: "Email address",
      messageLabel: "Message",
      messagePlaceholder: "Describe the project or inquiry",
      submitBtn: "Send message",
      successMsg: "Thank you for your message. Porthos Maritime will get back to you as soon as possible.",
      errorMsg: "An error occurred. Please try again later or call directly."
    },

    // Footer
    footer: {
      desc: "Professional advisory and operational support for complex projects in the maritime sector.",
      contact: "Contact",
      shortcuts: "Shortcuts",
      allRightsReserved: "All rights reserved."
    }
  }
};
